import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import router from '@/router' // 引入路由实例

// create an axios instance
const service = axios.create({
  baseURL: '/', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authorization'] = 'token ' + getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    return res
    
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 20000) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    if (error.response && error.response.status === 400) {
      Message({
        message: error.response.data.non_field_errors || error.response.data,
        type: 'error',
        duration: 5 * 1000
      })
      // ✅ 返回Promise.reject，让错误传递到后续catch
      return Promise.reject(new Error(error.response.data.non_field_errors || '400 Bad Request'))
    } else if (error.response && error.response.status === 401) {
      Message({
        message: '登录超时，请重新登录',
        type: 'error',
        duration: 3 * 1000
      })
      // 立即清除 token 和用户状态
      return store.dispatch('user/resetToken').then(() => {
        // 重要：确保清除 token 后再跳转
        // 修复 1: 移除 setTimeout，立即跳转
        // 修复 2: 添加 redirect 参数记录当前页面
        router.push({
          path: '/login',
          query: { 
            redirect: router.currentRoute.fullPath 
          }
        })
          
        // 修复 3: 返回一个 resolved Promise 中断后续错误处理
        return Promise.resolve({ code: 401, message: '登录已过期' })
      })
      return
    }
    Message({
      message: '请求错误，请稍后重试',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
